<template>
  <div class="card p-4">
    <div style="margin-top: 1em" class="row">
      <div class="form-group col-md-6">
        <w-input :model="$schema.firstName" />
      </div>

      <div class="form-group col-md-6">
        <w-input :model="$schema.lastName" />
      </div>
    </div>

    <div class="form-group">
      <w-input :model="$schema.email" />
    </div>

    <div class="col-12">
      <button class="btn btn-primary float-right" @click="save">
        Zapisz
      </button>
    </div>
  </div>
</template>

<script>
import { formViewMixin } from '@/mixins/formView';
import schema from '@/schemas/profile.schema';

const emptyData = () => ({
  email: '',
  firstName: '',
  lastName: '',
  gdprAccepted: true
});

// @vuese
// Edycja profilu
// @group Profile
export default {
  mixins: [
    formViewMixin(
      'profile',
      { updated: 'Zaktualizowano dane profilu.', updateError: 'Nie udało się zaktualizować danych profilu.' },
      emptyData
    )
  ],
  schema
};
</script>
